import React, { useState } from "react";

const TagInput = ({ value, onChange, placeholder = "Type keyword and press Enter or comma..." }) => {
  const [inputValue, setInputValue] = useState("");

  const getTags = () => {
    if (Array.isArray(value)) return value;
    if (typeof value === "string" && value.trim() !== "") {
      return value.split(",").map((t) => t.trim()).filter(Boolean);
    }
    return [];
  };

  const tags = getTags();

  const updateTags = (newTags) => {
    onChange(newTags.join(", "));
  };

  const addTag = (text) => {
    const trimmed = text.trim().replace(/,/g, "");
    if (trimmed && !tags.includes(trimmed)) {
      const newTags = [...tags, trimmed];
      updateTags(newTags);
    }
    setInputValue("");
  };

  const removeTag = (indexToRemove) => {
    const newTags = tags.filter((_, idx) => idx !== indexToRemove);
    updateTags(newTags);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addTag(inputValue);
    } else if (e.key === "Backspace" && !inputValue && tags.length > 0) {
      removeTag(tags.length - 1);
    }
  };

  const handleBlur = () => {
    if (inputValue.trim()) {
      addTag(inputValue);
    }
  };

  return (
    <div
      className="form-control d-flex flex-wrap align-items-center p-1"
      style={{
        minHeight: "38px",
        maxHeight: "150px",
        overflowY: "auto",
        cursor: "text",
        gap: "6px",
        backgroundColor: "#ffffff",
      }}
    >
      {tags.map((tag, idx) => (
        <span
          key={idx}
          className="badge bg-primary d-inline-flex align-items-center px-2 py-1"
          style={{
            fontSize: "12px",
            borderRadius: "12px",
            maxWidth: "100%",
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: "1.2",
          }}
        >
          <span>{tag}</span>
          <span
            className="ms-1 fw-bold text-white"
            style={{
              cursor: "pointer",
              marginLeft: "6px",
              fontSize: "14px",
              lineHeight: "1",
            }}
            onClick={(e) => {
              e.stopPropagation();
              removeTag(idx);
            }}
          >
            &times;
          </span>
        </span>
      ))}
      <input
        type="text"
        className="border-0 shadow-none"
        style={{
          outline: "none",
          background: "transparent",
          flex: "1 1 100px",
          minWidth: "100px",
          fontSize: "14px",
          padding: "2px 4px",
        }}
        placeholder={tags.length === 0 ? placeholder : "Add more..."}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
      />
    </div>
  );
};

export default TagInput;
